<div
  class="flex flex-col gap-2"
  [style.width]="config().width"
>
  @if (config().label) {
    <app-dynamic
      componentName="DynamicText"
      [props]="{ config: labelConfig() }"
    />
  }

  <div class="flex items-center gap-2">
    <!-- Leading Marker -->

    @if (config().startLabel) {
      <div class="w-3 h-3 rounded-full bg-(--progressbar-marker-active-color)"></div>
    }

    <!-- Progress Track -->
    <div class="flex-1 h-2 rounded-full gap-7 bg-(--progressbar-track-background) relative">
      <div
        class="absolute inset-y-0 left-0 rounded-full bg-(--progressbar-track-fill-color)"
        [style.width.%]="progressPercent()"
      ></div>
    </div>

    <!-- Ending Marker -->
    @if (config().endLabel) {
      <div
        [class]="
          'w-3 h-3 rounded-full ' +
          (isCompleted() ? 'bg-(--progressbar-marker-active-color)' : 'bg-(--progressbar-marker-idle-color)')
        "
      ></div>
    }
  </div>

  <!-- Labels -->
  @if (config().startLabel || config().endLabel) {
    <div class="flex justify-between">
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: startLabelConfig() }"
      />
      <app-dynamic
        componentName="DynamicText"
        [props]="{ config: endLabelConfig() }"
      />
    </div>
  }
</div>
